<script>
import baseMixin from '@/mixins/baseMixin'
import dayjs from '@/services/date'
import DateFormatToken from '@/constants/date/DateFormatToken'
import { TimesheetOperationTypeInts } from '@/constants/disputes/TimesheetOperationType'
import timesheetMixin from '@/mixins/timesheetMixin'
import { highlightText } from '@/helpers/search-helpers'
export default {
  name: 'DisputesTableBookingDateV2',
  mixins: [baseMixin, timesheetMixin],
  props: {
    dispute: {
      type: Object,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
  },
  computed: {
    DateFormatToken() {
      return DateFormatToken
    },
    candidateHasSubmitted() {
      return this.dispute.hasCandidateTimesheet
    },
    clientHasSubmitted() {
      return this.dispute.hasClientTimesheet
    },
    getClientTimes() {
      if (!this.clientHasSubmitted) return null
      return this.convertTimeIntoDate(
        this.dispute.clientTimesheet.startTime,
        this.dispute.clientTimesheet.endTime,
        this.dispute.startTimeLocal
      )
    },
    getCandidateTimes() {
      if (!this.candidateHasSubmitted) return null
      return this.convertTimeIntoDate(
        this.dispute.candidateTimesheet.startTime,
        this.dispute.candidateTimesheet.endTime,
        this.dispute.startTimeLocal
      )
    },
    hasCandidateModifiedTimesheet() {
      if (!this.candidateHasSubmitted) return false
      return (
        this.dispute?.candidateTimesheet?.operationType ===
        TimesheetOperationTypeInts.MODIFY
      )
    },
    hasClientModifiedTimesheet() {
      if (!this.clientHasSubmitted) return false
      return (
        this.dispute?.clientTimesheet?.operationType ===
        TimesheetOperationTypeInts.MODIFY
      )
    },
    getLatestAndPreviousBookingTime() {
      const candidateSubmittedDate = this.hasCandidateModifiedTimesheet
        ? this.dispute.candidateTimesheet?.submittedDateUtc
        : null
      const clientSubmittedDate = this.hasClientModifiedTimesheet
        ? this.dispute.clientTimesheet?.submittedDateUtc
        : null

      let latestStartDate = this.dispute.startTimeLocal
      let latestEndDate = this.dispute.endTimeLocal

      let previousStartDate = null
      let previousEndDate = null

      if (candidateSubmittedDate && clientSubmittedDate) {
        const candidateTimesheetIsLatest = dayjs(
          candidateSubmittedDate
        ).isAfter(dayjs(clientSubmittedDate))

        latestStartDate = candidateTimesheetIsLatest
          ? this.getCandidateTimes.startTimeLocal
          : this.getClientTimes.startTimeLocal
        latestEndDate = candidateTimesheetIsLatest
          ? this.getCandidateTimes.endTimeLocal
          : this.getClientTimes.endTimeLocal

        previousStartDate = !candidateTimesheetIsLatest
          ? this.getCandidateTimes.startTimeLocal
          : this.getClientTimes.startTimeLocal
        previousEndDate = !candidateTimesheetIsLatest
          ? this.getCandidateTimes.endTimeLocal
          : this.getClientTimes.endTimeLocal
      } else if (candidateSubmittedDate) {
        latestStartDate = this.getCandidateTimes.startTimeLocal
        latestEndDate = this.getCandidateTimes.endTimeLocal

        previousStartDate = this.dispute.startTimeLocal
        previousEndDate = this.dispute.endTimeLocal
      } else if (clientSubmittedDate) {
        latestStartDate = this.getClientTimes.startTimeLocal
        latestEndDate = this.getClientTimes.endTimeLocal

        previousStartDate = this.dispute.startTimeLocal
        previousEndDate = this.dispute.endTimeLocal
      }

      return {
        latest: this.compileDateString(latestStartDate, latestEndDate),
        previous: previousStartDate
          ? this.compileDateString(previousStartDate, previousEndDate)
          : null,
      }
    },
    showPreviousBookingTime() {
      return !!this.getLatestAndPreviousBookingTime.previous
    },
  },
  methods: {
    highlightText,
    formatDate(d, format = DateFormatToken.ll) {
      return dayjs(d).locale(this.$i18n.locale).format(format)
    },
    convertTimeIntoDate(startTime, endTime, bookingStartDate) {
      const startTimeObj = dayjs(startTime, DateFormatToken.HHmmss)
      const endTimeObj = dayjs(endTime, DateFormatToken.HHmmss)

      const startTimeLocal = dayjs(bookingStartDate)
        .set('hours', startTimeObj.hour())
        .set('minutes', startTimeObj.minute())
      const endTimeLocal = dayjs(bookingStartDate)
        .set('hours', endTimeObj.hour())
        .set('minutes', endTimeObj.minute())

      return { startTimeLocal, endTimeLocal }
    },
    compileDateString(startTimeLocal, endTimeLocal) {
      return `${this.formatDate(startTimeLocal)} - ${this.formatDate(
        startTimeLocal,
        DateFormatToken.LT
      )} - ${this.formatDate(endTimeLocal, DateFormatToken.LT)}`
    },
  },
}
</script>

<template>
  <div>
    <div>
      <span
        v-sanitized-html="
          highlightText(getLatestAndPreviousBookingTime.latest, search)
        "
      ></span>
    </div>
    <div
      v-if="showPreviousBookingTime"
      class="text-decoration-line-through text-caption opacity-5"
    >
      <span
        v-sanitized-html="
          highlightText(getLatestAndPreviousBookingTime.previous, search)
        "
      ></span>
    </div>
  </div>
</template>
